import * as React from 'react';
import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';
import { BackOrderHistory, PlanInformation } from 'types/api/backorder';
import { TableCell } from 'types/common/table';

interface Props<T> {
  planInformation?: T[];
  header: TableCell[];
  columns: TableCell<T>[];
}

const PlanTable = <T extends PlanInformation | BackOrderHistory>({
  planInformation,
  header,
  columns,
}: Props<T>) => {
  return (
    <>
      <DataTableHeader header={header} />
      <NewDataTableBody dataList={planInformation ? planInformation : []} columns={columns} />
    </>
  );
};

export default PlanTable;
